import React from 'react';
import parse from 'html-react-parser';
import SearchForm from '@ecs/tng-common/src/components/search-form/SearchForm';
import SEO from '@ecs/tng-common/src/components/seo/SEO';
import LayoutFull from '../components/LayoutFull';
// styles
import '../styles/page-404.scss';

interface IMatches {
  match: RegExp;
  urlToDisplay: string;
  urlToNavigate: string;
}
type NotFoundState = {
  title: string;
  subtitle: string;
};
class NotFoundPage extends React.Component<object, NotFoundState> {
  didYouMeanListOfMatches: IMatches[] = [
    {
      match: /^\/bo.+/i,
      urlToDisplay: 'experian.com/boost',
      urlToNavigate:
        'https://experian.com/credit/score-boost/?cc=van_tvr_boost&intcmp=van_404_boost'
    },
    {
      match: /\/disput/i,
      urlToDisplay: 'experian.com/disputes',
      urlToNavigate: 'https://www.experian.com/disputes/?intcmp=404-dispute'
    },
    {
      match: /\/fraud|\/fruad|inialert/i,
      urlToDisplay: 'experian.com/fraud',
      urlToNavigate: 'https://www.experian.com/help/fraud-alert/?intcmp=404-fraud'
    },
    {
      match: /\/fr.+z/i,
      urlToDisplay: 'experian.com/freeze',
      urlToNavigate: 'https://www.experian.com/help/credit-freeze/?intcmp=404-freeze'
    },
    {
      match: /\/reportac/i,
      urlToDisplay: 'experian.com/reportaccess',
      urlToNavigate: 'https://www.experian.com/reportaccess/?intcmp=404-reportaccess'
    },
    {
      match: /\/upl.+d/i,
      urlToDisplay: 'experian.com/upload',
      urlToNavigate: 'https://www.experian.com/upload'
    },
    {
      match: /^\/kel.*/i,
      urlToDisplay: 'experian.com/kelce',
      urlToNavigate:
        'https://www.experian.com/money/experian-smart-money/?cc=van_sop_kelce&intcmp=van_404_kelce'
    },
    {
      match: /^\/smart.*/i,
      urlToDisplay: 'experian.com/smartmoney',
      urlToNavigate:
        'https://www.experian.com/money/experian-smart-money/?cc=van_tvr_smartmoney&intcmp=van_404_smartmoney'
    }
  ];

  constructor(props: object) {
    super(props);
    this.state = {
      title: 'We couldn’t find that page',
      subtitle: 'Let us help you find what you are looking for.'
    };
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      this.setHeadingValue();
      this.setSubHeadingValue();
    }
  }

  setHeadingValue() {
    if (this.ifCreditDetailsPage()) {
      this.setState({
        title: 'Sorry, we can’t locate the card you are trying to find'
      });
    }
  }

  setSubHeadingValue() {
    const matches: IMatches[] = this.returnMatches();
    if (this.ifCreditDetailsPage()) {
      this.setState({
        subtitle:
          'It may no longer be available on our site, or you may have clicked on a bad link. Why not <a href="/credit-cards/?intcmp=404-creditdetail">check out our other card offerings</a>.'
      });
    } else if (matches && matches.length) {
      // tracking
      if (window.s) window.s.tl(this, 'o', 'expcom:404:did-you-mean-shown');
      this.setState({
        subtitle: `Did you mean <a href="${matches[0].urlToNavigate}">${matches[0].urlToDisplay}</a>?`
      });
    }
  }

  returnMatches() {
    const arr: IMatches[] = this.didYouMeanListOfMatches.filter((element: IMatches) => {
      return document.location.pathname.match(element.match);
    });
    return arr;
  }

  ifCreditDetailsPage() {
    return document.location.pathname.indexOf('credit-cards/details/') > -1;
  }

  render() {
    return (
      <LayoutFull>
        <section className="pb-5 pb-lg-7 notfound-wrap">
          <div className="container container-py">
            <div className="row">
              <div className="col-sm-9 col-lg-8 col-xl-6">
                <div className="content-mb">
                  <h1>{parse(this.state.title)}</h1>
                  <p>{parse(this.state.subtitle)}</p>
                </div>
                <SearchForm
                  toShowCopyOnFocus={false}
                  ifFocusableOnLoad
                  className="rounded-2 overflow-hidden"
                  id="not-found-body"
                />
              </div>
            </div>
          </div>
        </section>
      </LayoutFull>
    );
  }
}

export default NotFoundPage;

export function Head() {
  return (
    <>
      <body data-op="EXP-ERR-PRI" />
      <SEO
        title="Experian - Page Not Found"
        description="Let us help you find what you are looking for. Please visit one of the links below or search."
      />
    </>
  );
}
